export default function LeftArrow() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3C8.82 3 3 8.82 3 16C3 23.18 8.82 29 16 29C23.18 29 29 23.18 29 16C29 8.82 23.18 3 16 3ZM10.2933 15.2933C10.1061 15.4808 10.0009 15.735 10.0009 16C10.0009 16.265 10.1061 16.5192 10.2933 16.7067L14.2933 20.7067C14.3849 20.8049 14.4953 20.8837 14.6179 20.9384C14.7406 20.993 14.873 21.0224 15.0073 21.0248C15.1416 21.0272 15.2749 21.0025 15.3995 20.9522C15.524 20.9019 15.6371 20.827 15.7321 20.7321C15.827 20.6371 15.9019 20.524 15.9522 20.3995C16.0025 20.2749 16.0272 20.1416 16.0248 20.0073C16.0224 19.873 15.993 19.7406 15.9384 19.618C15.8837 19.4953 15.8049 19.3849 15.7067 19.2933L13.4133 17H21C21.2652 17 21.5196 16.8946 21.7071 16.7071C21.8946 16.5196 22 16.2652 22 16C22 15.7348 21.8946 15.4804 21.7071 15.2929C21.5196 15.1054 21.2652 15 21 15H13.4133L15.7067 12.7067C15.8833 12.5171 15.9795 12.2664 15.9749 12.0073C15.9703 11.7482 15.8654 11.5011 15.6822 11.3178C15.4989 11.1346 15.2518 11.0297 14.9927 11.0251C14.7336 11.0205 14.4829 11.1167 14.2933 11.2933L10.2933 15.2933Z"
        fill="currentColor"
      />
    </svg>
  );
}
